import React, { useRef } from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';

import { NavigationDrawer } from 'components/navigation-drawer';
import { ProductOverview } from 'components/product-detail/product-overview';
import { LayoutContainerWrapper } from 'components/product-detail/styled';
import useMediaQuery from 'hooks/use-media-query';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useMenuContext } from 'state/menu';
import { useProductWizardContext } from 'state/product-wizard';
import { ProductWizardStep } from 'state/product-wizard/types';

import { NutritionInformation } from '../nutrition-information';
import { ProductHomeCta, ProductStaticMenuCta } from '../product-cta';
import { ProductCustomization } from '../product-customization';
import { ProductHome } from '../product-home';
import { DesktopMainViewContainer, ScrollableArea } from '../styled';

export interface IProductDetailLayoutProps {
  currentStep: ProductWizardStep;
  showStaticMenu: boolean;
}

export const ProductLayout: React.FC = () => {
  const { showStaticMenu } = useMenuContext();
  const { currentStep, itemToCustomize } = useProductWizardContext();
  const useEnableShowPickerAspectsInStaticMenu = useFlag(
    LaunchDarklyFlag.ENABLE_SHOW_PICKER_ASPECTS_IN_STATIC_MENU
  );

  const homePositionRef = useRef<number>(0);

  const isDesktop = useMediaQuery('desktop');

  const showStaticPickers = showStaticMenu && useEnableShowPickerAspectsInStaticMenu;

  if (isDesktop) {
    return (
      <>
        <ProductOverview />
        {/*
          One column layout if static menu and enable-show-picker-aspects-in-static-menu is off,
          Else two column layout
        */}
        {showStaticMenu && !useEnableShowPickerAspectsInStaticMenu ? (
          <Box width="400px" margin="0 auto">
            <ProductStaticMenuCta />
          </Box>
        ) : (
          <LayoutContainerWrapper>
            <NavigationDrawer
              mainView={
                <DesktopMainViewContainer>
                  <ScrollableArea>
                    <ProductHome showStaticPickers={showStaticPickers} />
                  </ScrollableArea>
                  {showStaticPickers ? (
                    <ProductStaticMenuCta showStaticPickers={showStaticPickers} />
                  ) : (
                    <ProductHomeCta />
                  )}
                </DesktopMainViewContainer>
              }
              sideView={
                itemToCustomize && <ProductCustomization itemToCustomize={itemToCustomize} />
              }
              isSideViewActive={
                !!itemToCustomize && currentStep === ProductWizardStep.ProductCustomization
              }
            />
          </LayoutContainerWrapper>
        )}
      </>
    );
  }

  return (
    <>
      {!!itemToCustomize && currentStep === ProductWizardStep.ProductCustomization ? (
        <ProductCustomization itemToCustomize={itemToCustomize} />
      ) : (
        <>
          <ProductOverview />
          {(!showStaticMenu || showStaticPickers) && (
            <ProductHome homePositionRef={homePositionRef} showStaticPickers={showStaticPickers} />
          )}
          <NutritionInformation />
          {showStaticMenu || showStaticPickers ? (
            <ProductStaticMenuCta showStaticPickers={showStaticPickers} />
          ) : (
            <ProductHomeCta />
          )}
        </>
      )}
    </>
  );
};
